module.exports = __webpack_public_path__ + "warning.706f5c69.gif";


//////////////////
// WEBPACK FOOTER
// ./client/components/warning.gif
// module id = 514
// module chunks = 0